import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/izvajalecOsemenjevanja";

export const fetchInseminationOperators = createAsyncThunk(
  "inseminationOperators/list",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchInseminationOperatorsPage = createAsyncThunk(
  "inseminationOperators/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchInseminationOperatorsBySifra = createAsyncThunk(
  "inseminationOperators/byCode",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`${baseUrl}/${sifra}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const operatorSlice = createSlice({
  name: "inseminationOperators",
  initialState: {
    list: [],
    page: null,
    byId: {},
    details: {},
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInseminationOperators.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;

        action.payload.forEach((item) => {
          state.byId[item.sifra] = item;
        });
      })
      .addCase(fetchInseminationOperators.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchInseminationOperators.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchInseminationOperatorsPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchInseminationOperatorsPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchInseminationOperatorsPage.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchInseminationOperatorsBySifra.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchInseminationOperatorsBySifra.fulfilled, (state, action) => {
        state.isLoading = false;
        const item = action.payload;
        if (item?.sifra) {
          state.byId[item.sifra] = item;
          state.details = item.sifra;
        }
      })
      .addCase(fetchInseminationOperatorsBySifra.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default operatorSlice.reducer;
